import { useSelector } from "react-redux";
import { Createpermission } from "../../../store/permission-store/permission-actions"; 
import PermissionForms from "../../../components/Forms/PermissionForms";
import { Getpermissions } from "../../../store/permission-store/permission-actions";
import { getTokenInfo } from "../../../utils/Guard";

const PermissionCreate = () => {
  const userInfo = getTokenInfo();
  const permission = useSelector((state) => state.permission.permission);
  


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <PermissionForms actionpermission={Createpermission} permission={permission} />
      </div>
    </>
  );
};
export default PermissionCreate;
